
import React from 'react'
import Icon from 'react-icon-base'

const FaLongArrowUp = props => (
    <Icon viewBox="0 0 40 40" {...props}>
        <g><path d="m28.6 11q-0.2 0.4-0.7 0.4h-5v27.9q0 0.3-0.2 0.5t-0.5 0.2h-4.3q-0.3 0-0.5-0.2t-0.2-0.5v-27.9h-5q-0.5 0-0.6-0.4t0.1-0.8l7.8-8.6q0.2-0.2 0.5-0.2 0.3 0 0.5 0.2l8 8.6q0.3 0.4 0.1 0.8z"/></g>
    </Icon>
)

export default FaLongArrowUp



// WEBPACK FOOTER //
// ./~/react-icons/fa/long-arrow-up.js